import React, { useState } from "react";

import "./Reckoner.css";

const Reckoner = () => {
  const [result, setResult] = useState("");

  function evaluate(fn) {
    return new Function("return " + fn)();
  }

  const handleClick = (event) => {
    if (result === "Error" || result === "0") {
      setResult(event.target.name);
    } else {
      setResult(result.concat(event.target.name));
    }
  };

  const clear = () => {
    setResult("");
  };

  const backspace = () => {
    setResult(result.slice(0, result.length - 1)); // result.length - 1 or -1
  };

  const calculate = () => {
    try {
      setResult(evaluate(result).toString());
    } catch (err) {
      setResult("Error");
    }
  };

  return (
    <>
      <div className="reckoner">
        <form>
          <input type="text" readOnly value={result} placeholder="result" />
        </form>
        <hr />
        <div className="inputKeypad">
          <button className="highlighted" onClick={clear} id="clear">
            Clear
          </button>
          <button className="highlighted" onClick={backspace} id="backspace">
            C
          </button>
          <button className="highlighted" name="/" onClick={handleClick}>
            &divide;
          </button>
          <button className="nrml" name="7" onClick={handleClick}>
            7
          </button>
          <button className="nrml" name="8" onClick={handleClick}>
            8
          </button>
          <button className="nrml" name="9" onClick={handleClick}>
            9
          </button>
          <button className="highlighted" name="*" onClick={handleClick}>
            &times;
          </button>
          <button className="nrml" name="4" onClick={handleClick}>
            4
          </button>
          <button className="nrml" name="5" onClick={handleClick}>
            5
          </button>
          <button className="nrml" name="6" onClick={handleClick}>
            6
          </button>
          <button className="highlighted" name="-" onClick={handleClick}>
            &ndash;
          </button>
          <button className="nrml" name="1" onClick={handleClick}>
            1
          </button>
          <button className="nrml" name="2" onClick={handleClick}>
            2
          </button>
          <button className="nrml" name="3" onClick={handleClick}>
            3
          </button>
          <button className="highlighted" name="+" onClick={handleClick}>
            +
          </button>
          <button className="nrml" name="0" onClick={handleClick}>
            0
          </button>
          <button className="nrml" name="." onClick={handleClick}>
            .
          </button>
          <button className="highlighted" onClick={calculate} id="result">
            =
          </button>
        </div>

        {/*<div className="neumorphism-3"></div>*/}
      </div>
    </>
  );
};

export default Reckoner;
